<mat-toolbar>
    <div class="flex items-center" [class.menu]="User?.RoleBooleans?.IsDeveloper || User?.RoleBooleans?.IsAdmin">
        @if (User == null) {
        <a class="w-[60px] h-[60px]" routerLink="/login"><img class="w-[60px] h-[60px]" src="../../assets/images/PEFLogo.png" matTooltip="Login Page" /></a>
        }
        @if (User != null && User.RoleBooleans.IsStudent) {
        <div class="w-[60px] h-[60px]"><img class="w-[60px] h-[60px]" src="../../assets/images/PEFLogo.png" /></div>
        }
        @if (smallScreen === false &&
        User != null &&
        (User.RoleBooleans.IsAdmin || User.RoleBooleans.IsDeveloper)) {
        <a class="w-[60px] h-[60px]" routerLink="/admin-home"><img class="w-[60px] h-[60px]" src="../../assets/images/PEFLogo.png" matTooltip="Home Page" /></a>
        }
        <app-nav-menu class="h-[60px]"></app-nav-menu>
    </div>
    @if (isDevMode === true && smallScreen === false) {
    <p class="text-red-500">
        <strong>Site is Using Training Data</strong>
    </p>
    }
    <div class="flex items-center">
        <button mat-icon-button (click)="help()" class="mr-[5px] text-white" matTooltip="Help"><mat-icon>question_mark</mat-icon></button>
        @if (User != null) {
        <div class="flex items-center">
            @if (smallScreen === false) {
            <app-user-info class="mr-[10px]"></app-user-info>
            }
            <button mat-mini-fab (click)="logout()" matTooltip="Logout"><mat-icon>exit_to_app</mat-icon></button>
        </div>
        }
    </div>
</mat-toolbar>
<div class="pt-[60px] pr-[20px] pb-[50px] pl-[20px]">
    <router-outlet></router-outlet>
</div>